<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Tiêu đề tiếng anh </span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-input :text="detailNews.name_en" @input="update" v-model="detailNews.name_en"></hnr-input>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Từ khóa SEO Tiếng anh </span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-input :text="detailNews.seo_key_en" @input="update" v-model="detailNews.seo_key_en"></hnr-input>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Tiêu đề SEO Tiếng anh </span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-input :text="detailNews.seo_name_en" @input="update" v-model="detailNews.seo_name_en"></hnr-input>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Nội dung SEO Tiếng anh </span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-area-input :text="detailNews.seo_description_en" @input="update" v-model="detailNews.seo_description_en"></hnr-area-input>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Nội dung tiếng anh</span>
      </v-col>
      <v-col cols="10" class="pa-1 mb-5">
        <ck-content
            id="lesson_content"
            :content="detailNews.description_en"
            @getData="updateContent"
            v-model="detailNews.description_en"
        ></ck-content>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HnrInput from '@/components/elements/hnr-input';
import HnrAreaInput from '@/components/elements/hnr-area-input';
import CkContent from "@/components/ck-content";
export default {
  props: {
    new: Object,
  },
  watch: {
    new: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.detailNews = newVal;
      }
    }
  },
  data() {
    return {
      detailNews: {}
    };
  },
  components: {
    HnrInput,
    HnrAreaInput,
    CkContent
  },
  methods: {
    updateContent(val) {
      this.detailNews.content_en = val;
    },
    onClick() {
    },
    update() {
      this.$emit("input");
    },
  },
};
</script>

<style lang="scss">
</style>
